"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SeeAllSkeleton = exports.HeaderSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
var _styles = require("../SearchPreview/styles");
var _styles2 = require("../styles");
const HeaderSkeleton = exports.HeaderSkeleton = (0, _mui.styled)(_styles2.UnifiedSkeleton)(({
  theme
}) => ({
  width: 150,
  minHeight: 28,
  [theme.breakpoints.up('md')]: {
    minHeight: 33,
    width: 200
  }
}));
const SeeAllSkeleton = exports.SeeAllSkeleton = (0, _mui.styled)(_styles.SeeAllResults)(({
  theme
}) => ({
  height: _constants.SEARCH_PREVIEW_SEE_ALL_HEIGHT
}));
//# sourceMappingURL=styles.js.map